module.exports = __webpack_public_path__ + "front/img/17.92b4f2d6.png";